exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2uuSN_W2PUZUCI7j-1hdRM{font-size:12px;font-weight:400}html[dir] ._2uuSN_W2PUZUCI7j-1hdRM{margin-top:20px;margin-bottom:20px}.XD_OxCfYiT_-8jfUrVzYX{vertical-align:middle}._3347b-MJgpuaz5oKXfCTJI{color:var(--neutralSecondary);vertical-align:middle}html[dir=ltr] ._3347b-MJgpuaz5oKXfCTJI{margin-left:7px}html[dir=rtl] ._3347b-MJgpuaz5oKXfCTJI{margin-right:7px}html[dir] ._6isp2U65BClj4lXNx6HmH{margin-top:5px}._2FzwNNMh24XRH7yMo-ab01{color:var(--neutralPrimary)}", ""]);
// Exports
exports.locals = {
	"panel": "_2uuSN_W2PUZUCI7j-1hdRM",
	"attachIcon": "XD_OxCfYiT_-8jfUrVzYX",
	"attachmentCountLabel": "_3347b-MJgpuaz5oKXfCTJI",
	"attachmentCollectionContainer": "_6isp2U65BClj4lXNx6HmH",
	"attachmentCollectionLabel": "_2FzwNNMh24XRH7yMo-ab01"
};